// Diagnostics view: recent diagnostic runs. For the Android Auto discoverability
// round this renders the captured manifest fields (permissions / categories) and
// a cross-check note (which required fields were present or missing).
//
// TODO(backend): powered by mock data until GET /nav-telemetry/diagnostics
// exists. See api.ts getDiagnostics and types.ts DiagnosticRun.

import { useEffect, useState } from "react";
import { getDiagnostics } from "../api.js";
import type { DiagnosticRun } from "../types.js";

export function Diagnostics() {
  const [runs, setRuns] = useState<DiagnosticRun[]>([]);

  useEffect(() => {
    let alive = true;
    getDiagnostics().then((r) => alive && setRuns(r));
    return () => {
      alive = false;
    };
  }, []);

  if (runs.length === 0) return <p className="muted">No diagnostic runs.</p>;

  return (
    <>
      <p className="muted">
        Recent diagnostic runs. Source: mock (no <code>GET /nav-telemetry/diagnostics</code> endpoint yet).
      </p>
      {runs.map((run) => (
        <div className="panel" key={`${run.roundId}-${run.deviceId}-${run.capturedAt}`}>
          <header style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <strong>{run.roundId}</strong>
            <span className={`sev ${run.crossCheck.ok ? "info" : "error"}`}>
              {run.crossCheck.ok ? "PASS" : "FAIL"}
            </span>
          </header>
          <p className="muted">
            {run.deviceId} · {new Date(run.capturedAt).toLocaleString()} · {run.manifest.packageName}
          </p>

          <h4>Manifest</h4>
          <table>
            <tbody>
              <tr>
                <td className="muted">minCarApiLevel</td>
                <td>{run.manifest.minCarApiLevel ?? "—"}</td>
              </tr>
              <tr>
                <td className="muted">permissions</td>
                <td>{run.manifest.permissions.join(", ") || "—"}</td>
              </tr>
              <tr>
                <td className="muted">categories</td>
                <td>{run.manifest.categories.join(", ") || "—"}</td>
              </tr>
            </tbody>
          </table>

          <h4>Cross-check</h4>
          {run.crossCheck.missing.length > 0 && (
            <p className="sev error">Missing: {run.crossCheck.missing.join(", ")}</p>
          )}
          <p>{run.crossCheck.note}</p>
        </div>
      ))}
    </>
  );
}
